import api from "@/api/index.ts";
import { IHomeState } from "@/i/home.state";
import { mainFactory } from "@/services/factory/main.ts";
import { IMerchantCoupons } from "@/i/coupons.state";

const initHomeState: IHomeState = {
  bannerCoupons: [],
  topMerchants: [],
  topCoupons: [],
  isLoading: false
};

export default {
  namespaced: true,
  state: initHomeState,
  getters: {
    getBannerImg: state => state.bannerCoupons,
    getTopMerchants: state => state.topMerchants,
    getTopCoupons: state => state.topCoupons,
    isLoading: state => state.isLoading
  },
  mutations: {
    updateState(state: IMerchantCoupons, newState: IMerchantCoupons) {
      state = Object.assign(state, newState);
    },
    isLoading(state: IMerchantCoupons, isLoading: boolean = true) {
      state.isLoading = isLoading;
    },
  },
  actions: {
    async updateHomeFromAPI({ commit }) {
      commit("isLoading");
      const { data } = await api.getMainData();
      commit("isLoading", false);
      commit("updateState", mainFactory(data));
      return Promise.resolve(data);
    }
  }
};
